export default function (
  str,
  dividers = ['[', ']', '{', '}', '~'],
  joiners = ['<span style="color: #33A1FB">', '</span>', '<span style="color: red">', '</span>', '<br>'],
) {
  let res = str;
  for (let i = 0; i < Math.min(dividers.length, joiners.length); i += 1) {
    res = res.split(dividers[i]).join(joiners[i]);
  }
  return res;
}
